// extracted by mini-css-extract-plugin
export default {"headings":"index_headings__3OR13","unsuccessful":"index_unsuccessful__3nwQA","unsuccessfulText":"index_unsuccessfulText__1X7S3","seeAllButton":"index_seeAllButton__3EI2x"};